import * as yup from 'yup';

export const AdministrationUserCreateStep4Schema = (
  t: (key: string, options?: { [key: string]: string }) => string,
): yup.AnyObjectSchema =>
  yup.object().shape({
    sortingCenters: yup.array().test('oneOfRequired', 'One field must be true', items => {
      if (!items) return false;
      const oneIsTrue = (item: boolean | undefined) => true === item;
      return items.some(oneIsTrue);
    }),
  });
